import React, { useState } from "react";
import axios from "axios";
const Contact = () => {
  const [name, setName] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [textarea, setTextarea] = useState("");
  const [services, setService] = useState([])
  const [budget, setBudget] = useState([])
  const updatearry = (e) => {
    const update = [...services, e]
    setService(update)
  }

  const Submit = () => {
    if (name === "" || lname === "" || email === "") {
      alert("Fill up the Form please!");
    } else {
      let items = {
        name, lname, email, phone, services,
        budget, textarea
      };
      console.log(items);
      let formData = new FormData(); //formdata object

      formData.append("first_name", items.name); //append the values with key, value pair
      formData.append("last_name", items.lname);
      formData.append("email", items.email);
      formData.append("phone_number", items.phone);
      formData.append('services', items.services)
      formData.append("budget", items.budget);
      formData.append("textarea", items.textarea);

      axios
        .post("https://hnhbackend.hnhtechsolutions.com/api/contact", formData, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => {
          console.log("res", res);

        });
    }
    setName("")
    setLname("")
    setEmail("")
    setPhone("")
    setTextarea("")
  };


  return (
    <>
      <div>
        <meta httpEquiv="content-type" content="text/html;charset=UTF-8" />
        {/*?php include("head.php") ?*/}
        <style
          dangerouslySetInnerHTML={{
            __html:
              '\n    .radio-btn-group, .checkbox-btn-group {\n        width: 100%;\n    }\n    .radio-btn-group .radio, .radio-btn-group .form-check, .checkbox-btn-group .radio, .checkbox-btn-group .form-check {\n        margin: 0 .25rem;\n    }\n    .radio-btn-group .radio label, .radio-btn-group .form-check label, .checkbox-btn-group .radio label, .checkbox-btn-group .form-check label {\n        background: #f5f5f5;\n        font-size: 20px;\n        padding: 0.7rem 2rem;\n        border-radius: 25px;\n        color: #00171f;\n        -webkit-transition: box-shadow 400ms ease;\n        transition: box-shadow 400ms ease;\n    }\n    .radio-btn-group .radio input[type="radio"], .radio-btn-group .radio input[type="checkbox"], .radio-btn-group .form-check input[type="radio"], .radio-btn-group .form-check input[type="checkbox"], .checkbox-btn-group .radio input[type="radio"], .checkbox-btn-group .radio input[type="checkbox"], .checkbox-btn-group .form-check input[type="radio"], .checkbox-btn-group .form-check input[type="checkbox"] {\n        display: none;\n    }\n    .radio-btn-group .radio input[type="radio"]:checked + label, .radio-btn-group .radio input[type="checkbox"]:checked + label, .radio-btn-group .form-check input[type="radio"]:checked + label, .radio-btn-group .form-check input[type="checkbox"]:checked + label, .checkbox-btn-group .radio input[type="radio"]:checked + label, .checkbox-btn-group .radio input[type="checkbox"]:checked + label, .checkbox-btn-group .form-check input[type="radio"]:checked + label, .checkbox-btn-group .form-check input[type="checkbox"]:checked + label {\n        background: #00a8e8;\n        color: #fff;\n        border-color: #0088bc;\n    }\n\n    .radio-selection-group .radio, .radio-selection-group .form-check, .checkbox-selection-group .radio, .checkbox-selection-group .form-check {\n        margin: 0 .2rem;\n        display: inline-block;\n    }\n    .radio-selection-group .radio label, .radio-selection-group .form-check label, .checkbox-selection-group .radio label, .checkbox-selection-group .form-check label {\n        display: block;\n        text-align: center;\n        border-radius: 25px;\n    }\n\n\n',
          }}
        />
        {/*?php include("nav.php") ?*/}
        {/* animsition-overlay start */}
        <main
          className="animsition-overlay"
          data-animsition-overlay={true}
          id="up"
        >
          {/* page-head start */}
          <section
            id="up"
            className="page-head flex-min-height-box dark-bg-2 typewriter-home"
          >
            {/* page-head-bg */}
            <div
              className="page-head-bg"
              style={{
                backgroundImage:
                  "url(assets/images/backgrounds/adam-solomon-WHUDOzd5IYU-unsplash.webp)",
              }}
            />
            <div className="bg-overlay" />
            {/* flex-min-height-inner start */}
            <div className="flex-min-height-inner">
              {/* container start */}
              <div className="container top-bottom-padding-120">
                <h2 className="overlay-loading2 medium-title red-color">
                  Contact
                </h2>
                <h3 className="large-title-bold text-color-4">
                  <span className="overlay-loading2 overlay-light-bg-1 tr-delay01">
                    Us
                  </span>
                  <br />
                </h3>
                <p className="d-flex-wrap top-margin-20 text-color-4">
                  <span className="small-title-oswald text-height-20 fade-loading tr-delay04 top-margin-10">
                    Creative team
                  </span>
                  <span className="small-title-oswald text-height-20 fade-loading tr-delay05 top-margin-10">
                    Innovation ideas
                  </span>
                  <span className="small-title-oswald text-height-20 fade-loading tr-delay06 top-margin-10">
                    Best services
                  </span>
                </p>
              </div>
              {/* container end */}
            </div>
            {/* flex-min-height-inner end */}
            {/* scroll-btn start */}
            <a href="#down" className="scroll-btn pointer-large">
              <div className="scroll-arrow-box">
                <span className="scroll-arrow" />
              </div>
              <div className="scroll-btn-flip-box">
                <span className="scroll-btn-flip" data-text="Scroll">
                  Scroll
                </span>
              </div>
            </a>
            {/* scroll-btn end */}
          </section>
          {/* page-head end */}
          {/* contact-form-box start */}
          <section id="down" className="dark-bg-1 contact-form-box">
            {/* flex-min-height-inner start */}
            <div className>
              {/* container start */}
              <div className="container top-padding-120">
                <h6 className="large-title-bold text-color-4">
                  Revolutionalize Your Digital Journey With A Smile.
                </h6>
                <p className="small-title-oswald text-color-4">Support</p>
                <h4 className="large-title text-color-4">
                  Discuss your digital revolutions with us
                </h4>
                {/* flex-container start */}
                <h4 className="text-color-4 top-bottom-padding-30">
                  I'm interested in following services
                </h4>
                <form
                  className="flex-container  top-padding-90"
                  action="contact-email.php"
                  method="post"
                >
                  {/* column start */}
                  <div className="three-columns">
                    <div className="content-right-margin-10">
                      <input
                        type="text"
                        placeholder="Enter your name"
                        name="first_name"
                        className="contact-form-control pointer-small"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value)
                        }
                        }
                      />
                    </div>
                  </div>
                  {/* column end */}
                  {/* column start */}
                  <div className="three-columns">
                    <div className="content-left-right-margin-5">
                      <input
                        type="text"
                        placeholder="Enter your last name"
                        name="last_name"
                        className="contact-form-control pointer-small"
                        value={lname}
                        onChange={(e) => {
                          setLname(e.target.value)
                        }
                        }
                      />
                    </div>
                  </div>
                  {/* column end */}
                  {/* column start */}
                  <div className="three-columns">
                    <div className="content-left-margin-10">
                      <input
                        type="email"
                        placeholder="Enter your email address"
                        name="email"
                        className="contact-form-control pointer-small"
                        value={email}
                        onChange={(e) => {

                          setEmail(e.target.value)
                        }
                        }
                      />
                    </div>
                  </div>
                  {/* column end */}
                  {/* column start */}
                  <div className="three-columns">
                    <div className="content-left-margin-10">
                      <input
                        type="text"
                        placeholder="Phone Number"
                        name="phone"
                        className="contact-form-control pointer-small"
                        value={phone}
                        onChange={(e) => {

                          setPhone(e.target.value)
                        }
                        }
                      />
                    </div>
                  </div>
                  {/* column end */}
                  {/* column start */}
                  <div className="twelve-columns">
                    <textarea
                      placeholder="Company Group"
                      name="company_group"
                      className="contact-form-control pointer-small"
                      defaultValue={""}
                      value={textarea}
                      onChange={(e) => {

                        setTextarea(e.target.value)
                      }
                      }
                    />
                  </div>
                 
                </form>
              </div>
              {/* container end */}
            </div>
            {/* flex-min-height-inner end */}
            <div className="container bottom-padding-120">
              {/*<form action="">*/}
              <div className="checkbox-btn-group checkbox-selection-group">
                <h4 className="text-color-4 top-bottom-padding-30">
                  I'm interested in following services
                </h4>
                <div className="form-check pointer-large">
                  <input
                    type="checkbox"
                    name="design"
                    defaultValue="Design"
                    id="button_1"
                    value={services}
                    onChange={(e) => {
                      updatearry(e.target.value)
                    }
                    }
                  />
                  <label htmlFor="button_1">Design</label>
                </div>
                <div className="form-check pointer-large">
                  <input
                    type="checkbox"
                    name="web_dev"
                    defaultValue="Website Development"
                    id="button_2"
                    onChange={(e) => {

                      updatearry(e.target.value)
                    }
                    }

                  />
                  <label htmlFor="button_2">Website Development</label>
                </div>
                <div className="form-check pointer-large">
                  <input
                    type="checkbox"
                    name="app_dev"
                    defaultValue="App Development"
                    id="button_3"
                    value={services}
                    onChange={(e) => {

                      updatearry(e.target.value)
                    }
                    }

                  />
                  <label htmlFor="button_3">App Development</label>
                </div>
                <div className="form-check pointer-large">
                  <input
                    type="checkbox"
                    name="branding"
                    defaultValue="Branding"
                    id="button_4"
                    value={services}
                    onChange={(e) => {

                      updatearry(e.target.value)
                    }
                    }

                  />
                  <label htmlFor="button_4">Branding</label>
                </div>
                <div className="form-check pointer-large">
                  <input
                    type="checkbox"
                    name="marketing"
                    defaultValue="Marketing"
                    id="button_5"
                    value={services}
                    onChange={(e) => {

                      updatearry(e.target.value)
                    }
                    }

                  />
                  <label htmlFor="button_5">Marketing</label>
                </div>
                <div className="form-check pointer-large">
                  <input
                    type="checkbox"
                    name="others"
                    defaultValue="Others"
                    id="button_6"
                    value={services}
                    onChange={(e) => {

                      updatearry(e.target.value)
                    }
                    }

                  />
                  <label htmlFor="button_6">Others</label>
                </div>
              </div>
              <div className="checkbox-btn-group checkbox-selection-group">
                <h4 className="text-color-4 top-bottom-padding-30">
                  Expected Budget
                </h4>
                <div className="form-check pointer-large">
                  <input
                    type="radio"
                    name="radio"
                    defaultValue="$5,000 - $10,000"
                    v-model="checked"
                    id="unit1"
                    onChange={(e) => {

                      setBudget(e.target.value)
                    }
                    }

                  />
                  <label htmlFor="unit1" className="small">
                    $5,000 - $10,000
                  </label>
                </div>
                <div className="form-check pointer-large">
                  <input
                    type="radio"
                    name="radio"
                    defaultValue="$10,000 - $100,000"
                    id="unit2"
                    value={budget}
                    onChange={(e) => {

                      setBudget(e.target.value)
                    }
                    }

                  />
                  <label htmlFor="unit2">$10,000 - $100,000</label>
                </div>
                <div className="form-check pointer-large">
                  <input
                    type="radio"
                    name="radio"
                    defaultValue="$100,000 - $1,000,000"
                    id="unit3"
                    value={budget}
                    onChange={(e) => {

                      setBudget(e.target.value)
                    }
                    }

                  />
                  <label htmlFor="unit3">$100,000 - $1,000,000 $</label>
                </div>
                <div className="form-check pointer-large">
                  <input
                    type="radio"
                    name="radio"
                    defaultValue="$1,000,000 +"
                    id="unit4"
                    value={budget}
                    onChange={(e) => {

                      setBudget(e.target.value)
                    }
                    }

                  />
                  <label htmlFor="unit4">$1,000,000 +</label>
                </div>
              </div>
              <div className="form-check top-padding-30">
                <label className="form-check-label">
                  <input
                    type="checkbox"
                    name="nda"
                    id="nda"
                    defaultValue={1}
                    value={services}
                    className="form-check-input"
                  // onChange={(e)=>{

                  //   updatearry(e.target.value)}
                  // }

                  />
                  <h5
                    className="text-color-4"
                    style={{ display: "inline-block" }}
                  >
                    Send NDA
                  </h5>
                </label>
              </div>
              <div
                data-animation-child
                className="arrow-btn-box top-margin-30 fade-anim-box tr-delay05 animated fade-anim"
                data-animation="fade-anim"
              >
                <button type="submit" className="arrow-btn pointer-large"
                  onClick={Submit}>
                  SEND
                </button>
              </div>
            </div>
          </section>
          {/* contact-form-box end */}
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2376.114732088426!2d-2.248077384157702!3d53.44853528000056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487bb21b080b3a0b%3A0x5a67d62f391345bc!2s300%20Princess%20Rd%2C%20Manchester%20M14%207HR%2C%20UK!5e0!3m2!1sen!2s!4v1588714903417!5m2!1sen!2s"
            width="100%"
            height={550}
            frameBorder={0}
            style={{ border: 0 }}
            allowFullScreen
            aria-hidden="false"
            tabIndex={0}
          />
          {/* flex-min-height-box start */}

          <div className="light-bg-1 top-bottom-padding-60">
            <div className="flex-container">
              <div className="four-columns form-group text-center">
                <img
                  src="assets/images/backgrounds/general_info_sale_icon.webp"
                  className="img-fluid mb-3"
                  style={{ width: 40 }}
                />
                <h3 className>General Information &amp; Sales</h3>
                <h4 className>sales@hnhtechsolutions.com</h4>
              </div>
              <div className="four-columns form-group text-center">
                <img
                  src="assets/images/backgrounds/support_icon.webp"
                  className="img-fluid mb-2"
                  style={{ width: 40 }}
                />
                <h3 className="f-ebold m-0">Support</h3>
                <h4 className="f-20 theme-yellow">
                  support@hnhtechsolutions.com
                </h4>
              </div>
              <div className="four-columns form-group text-center">
                <img
                  src="assets/images/backgrounds/career_icon.webp"
                  className="mb-2"
                  style={{ width: 40 }}
                />
                <h3 className="f-ebold m-0">Career</h3>
                <h4 className="f-20 theme-yellow">
                  jobs@hnhtechsolutions.com
                </h4>
              </div>
            </div>
          </div>
        </main>
        {/* animsition-overlay end */}
        {/*?php include("footer.php") ?*/}
      </div>
    </>
  );
}

export default Contact;
